import { hexToRGB, rgbToNumber } from "../util/color";

export const colorsHex = [
    "#1DB0FD",
    "#1AC0F2",
    "#2FD3DD",
    "#84C8B1",
    "#74D8C0",
    "#D4A989",
    "#D5B47F",
    "#ECAF6E",
    "#FD7D70",
    "#B16080",
    "#A75A7C",
    "#745388",
    "#6C5589",
    "#585987",
    "#4A5785",
];

export const colorsRGB = colorsHex.map(hexToRGB);

export const colorsNum = colorsRGB.map(rgbToNumber);
